import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetUsersOnlineInterface } from 'domain/usecases';

export class RemoteGetUsersOnline implements GetUsersOnlineInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetUsersOnlineInterface.Params,
  ): Promise<GetUsersOnlineInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: generateUrl(this.url, {
        limit: params?.limit,
      }),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
